import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Brand } from "@/components/Brand";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (e2) { setErr(apiError(e2.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f8fafc] p-6">
      <div className="fade-in w-full max-w-sm">
        <div className="mb-8"><Brand /></div>
        {done ? (
          <div data-testid="forgot-success" className="rounded-xl border border-emerald-200 bg-emerald-50 p-6 text-center">
            <MailCheck className="mx-auto h-10 w-10 text-emerald-600" />
            <h2 className="mt-3 font-heading text-lg font-bold text-[#0a192f]">Bağlantı gönderildi</h2>
            <p className="mt-1 text-sm text-slate-600">
              Bu e-posta kayıtlıysa şifre sıfırlama bağlantısı gönderildi. Gelen kutunuzu kontrol edin.
            </p>
          </div>
        ) : (
          <form onSubmit={submit}>
            <h2 className="font-heading text-2xl font-bold text-[#0a192f]">Şifre Sıfırlama</h2>
            <p className="mt-1 text-sm text-slate-500">E-posta adresinize sıfırlama bağlantısı gönderelim</p>
            {err && <div className="mt-4 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">{err}</div>}
            <div className="mt-6">
              <Label htmlFor="email">E-posta</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="forgot-email-input" className="mt-1.5" />
            </div>
            <Button type="submit" disabled={loading} data-testid="forgot-submit-button"
              className="mt-6 w-full bg-emerald-600 hover:bg-emerald-700">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Bağlantı Gönder"}
            </Button>
          </form>
        )}
        <Link to="/login" className="mt-6 flex items-center justify-center gap-1 text-sm text-slate-500 hover:text-slate-700">
          <ArrowLeft className="h-4 w-4" /> Girişe dön
        </Link>
      </div>
    </div>
  );
}
